module.exports = __webpack_public_path__ + "img/Antique Oak.816c50db.jpg";